<template>
  <section
    v-if="props.data.content"
    class="htmlContent oldTypography"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container">
      <strong
        v-if="props.data.title"
        class="label text-primary"
      >{{ props.data.title }}</strong>

      <div
        v-if="props.data.content"
        v-html="convertToHtml(props.data.content)"
      ></div>
    </div>
  </section>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.htmlContent {
  &:deep(h1) {
    @apply mb-4;
  }

  &:deep(hr) {
    @apply mb-6;
  }

  &:deep(ul),
  &:deep(ol) {
    @apply ml-4;
    li {
      list-style-type: disc;
    }
  }
}
</style>
